import { Box, Button, Heading, Text } from '@wix/design-system';
import {
  Ellipsis,
  Title as PackagePickerTitle,
} from '@wix/package-picker-components';
import { useAppTitles } from 'components/AppTitle/useAppTitles';
import { BackButton } from 'components/BackButton/AdvancedPlans/BackButton';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getDomainName } from 'utils';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { AllPlansInclude } from './AllPlansInclude';
import s from './Title.scss';

interface TitleProps {
  showBackButton: boolean;
  onBack(): void;
  currentStep: number;
  isSecondStepDisabled: boolean;
  rootStore: RootStore;
}

export const TitleComp: React.FC<TitleProps> = ({
  showBackButton,
  onBack,
  currentStep,
  isSecondStepDisabled,
  rootStore,
}) => {
  const { t } = useTranslation();
  const { appTitle, appSubtitle } = useAppTitles(rootStore.appStore);
  const domainName = getDomainName(rootStore.appStore.experiments);
  const {
    isAnonymous,
    getSignInRedirectionLink,
    appContext: { biLogger },
  } = rootStore.appStore;

  const subTitle = isAnonymous && (
    <Box width='60%' textAlign='center' margin='0px auto'>
      <Text className={s.semiBold}>{t(appSubtitle)}</Text>
    </Box>
  );

  const handleAnonymousCtaClick = () => {
    const targetUrl = getSignInRedirectionLink();
    biLogger.logAnonymousCtaClick({ targetUrl, ctaName: 'anonymous-top-cta' });
    window.open(targetUrl, '_self');
  };

  const title = (
    <Trans
      i18nKey={appTitle}
      values={{ domainName }}
      components={{
        ellipsis: domainName ? (
          <Ellipsis
            text={domainName}
            as={Heading}
            componentProps={{ size: 'large' }}
            maxWidth={350}
            position="bottom"
          />
        ) : (
          <></>
        ),
      }}
    />
  );

  return (
    <PackagePickerTitle
      className={s.titleContainer}
      title={title}
      subTitle={subTitle}
      size='large'
    >
      <>
        {isAnonymous && (
          <Box align='center' marginTop='18px' marginBottom='18px'>
            <Button skin='premium' onClick={handleAnonymousCtaClick}>
              {t('premium-purchase-plan.anonymous.header.cta')}
            </Button>
          </Box>
        )}
        <Box direction='horizontal' marginTop='18px'>
          {showBackButton && (
            <BackButton
              className={s.backButton}
              handleOnBackButtonClick={onBack}
              currentStep={currentStep}
              isSecondStepDisabled={isSecondStepDisabled}
            />
          )}
          <AllPlansInclude />
        </Box>
      </>
    </PackagePickerTitle>
  );
};

export const Title = withInjectedRootStore(TitleComp);
